import { createContext } from "react"

const CurrentLocation = createContext()

export default CurrentLocation
